<div class="day-selector">
  <button class="day-nav-button" [disabled]="prevDisabled() || loadingDirection() !== null" (click)="onPrevClick()">
    @if (loadingDirection() === 'prev') {
      <oph-loading [diameter]="20"></oph-loading>
    } @else {
      <mat-icon svgIcon="chevron-left"></mat-icon>
    }
  </button>

  <div class="day-label-wrapper">
    <span class="day-label" [@slideLabel]="animationKey()">
      {{ displayText() }}
    </span>
  </div>

  <button class="day-nav-button" [disabled]="nextDisabled() || loadingDirection() !== null" (click)="onNextClick()">
    @if (loadingDirection() === 'next') {
      <oph-loading [diameter]="20"></oph-loading>
    } @else {
      <mat-icon svgIcon="chevron-right"></mat-icon>
    }
  </button>
</div>
